import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpOverlayComponent, SpOverlayContainerComponent } from './sp-overlay.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
  declarations: [
    SpOverlayComponent,
    SpOverlayContainerComponent
  ],
  imports: [
    CommonModule,
    ProgressSpinnerModule
  ],
  exports: [SpOverlayComponent, SpOverlayContainerComponent]
})
export class SpOverlayModule { }
